import { ReactNode } from 'react';

interface FeedGroupDividerProps {
  label: string;
}

// Sticky section header rendered between activity groups. Sits inside the scrollable list body
// and remains pinned at the top edge as the user scrolls past its group.
export const FeedGroupDivider = ({ label }: FeedGroupDividerProps): ReactNode => (
  <div className='activity-feed-list-group-header'>{label}</div>
);
